import { render, staticRenderFns } from "./PurchaseRequest.vue?vue&type=template&id=8181075c&scoped=true"
import script from "./PurchaseRequest.vue?vue&type=script&lang=js"
export * from "./PurchaseRequest.vue?vue&type=script&lang=js"
import style0 from "./PurchaseRequest.vue?vue&type=style&index=0&id=8181075c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8181075c",
  null
  
)

export default component.exports